/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  symptomCheckerApiUrl: 'https://dev-conv-analytic-ai-app-bsdsdff8b0bhc9cx.southindia-01.azurewebsites.net/api',
  tenantId:"c9d4c053-49b6-410c-bc78-2d54a9991870",
  branchId:"3d490a70-94ce-4d15-9494-5248280c2ce5",
  passwordExpiredDays:180,
  ResetpasswordNotificationDays:10,
  //*************** If use Prod or Demo URL uncomment this 3 line *********** by Raja
  patientCusID:"27590791",
  patientTenantId:"6bced242-032d-47d6-e7cb-08d8f2bf3f35",
  patientBranchId:"82b28344-d04e-41a0-6465-08d8f2bf3fc3",
  
  dentaliaTenantId:"C70B3D19-3A54-4527-1885-08DB16734232",
  dentalidBranchId:"38319400-77E8-4280-806A-293615CD724E",

 //Demo Patient Portal
  virtualTenant:'6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4',
  virtualBranch:'4e54f59e-226b-42a3-8ef2-cda3ac8fc727',
  virtualTenantID:'29528982',
 
  // Preprod and Prod Patient Portal
  // virtualTenant:'d29cc395-1670-43eb-f256-08dac9ecc7ac',
  // virtualBranch:'85307fd9-d69a-4b18-8daf-16fb57751469',
  // virtualTenantID:'16640732',

  onBoardTID:'6bced242-032d-47d6-e7cb-08d8f2bf3f35',
  
  production: true,
  speechBackendUrl: 'https://dev-voice-to-text-app-a8a4d0dabeerfjah.southindia-01.azurewebsites.net',
  convoAIUrl: 'https://dev-conv-ai-app-d8fqandzf0b9a8d7.southindia-01.azurewebsites.net',
  // convoAIUrl: 'http://localhost:5000',

  //Insurence Login
  InsBranchId :	"cba9abda-38a7-4732-bf2d-cda6f1c4baeb",
  InsTenant  :	"9a785f8c-eef7-40ff-739a-08db575b13a5",
  InsCusId : "90968813",


  brandCode:{key:'ezovion',value:'Ezovion', templateId:'6BCED242-032D-47D6-E7CB-08D8F2BF3F35',templateUserId:'167'},
  // Grameen -> { key:'shukhee', value:'Shukhee', templateId:'8E89105E-82D7-4C3F-151A-08DD445A6D1B',templateUserId:'5586'}

  // apiUrl:'https://localhost:44389/api',
  // baseUrl:'https://localhost:44389/api',
  apiUrl:'https://dev-hms-portal-app-win-cacsd3d4gzbsefcv.southindia-01.azurewebsites.net/api',
  baseUrl:'https://dev-hms-portal-app-win-cacsd3d4gzbsefcv.southindia-01.azurewebsites.net/api',
  // abhaUrl:'https://ez-hms-dev-abha-app-ser-win.azurewebsites.net/api/',
      abhaUrl  :'https://dev-abha-app-crdgfyhdgkezbad8.southindia-01.azurewebsites.net/api/',
  deploymentType:'cloud', //onprem & cloud  // If Both onprem,cloud
  //https://localhost:7282/
  
  mailApiUrl:'https://teleduce.corefactors.in/send-email-json-otom/facaefbd-e079-4698-a368-6d81a5a1272e/1016/',
    




  // pacsUrl - Demo
  pacsUrl:'https://dev-pacs-app-dtgge3h0dvhncxaf.southindia-01.azurewebsites.net',

  // pacsUrl - QA
  // pacsUrl:'https://qa-pacs-app-crd3bndmcvengydj.southindia-01.azurewebsites.net',

  //python Service Demo
  pythonUrl:'https://dev-woundcare-app-g3e4hygbg3d9dvgq.southindia-01.azurewebsites.net',

  //python Service QA
  // pythonUrl:'https://qa-woundcare-app-hje7dtf3ebffdsc6.southindia-01.azurewebsites.net',

  // Google Maps JavaScript API keys - previously duplicated as literals across app.module.ts,
  // patient-portal.module.ts and maps.module.ts. Consolidated here so rotating any of them is a
  // one-line change instead of a grep across the app. NOTE: these are still compiled into the
  // client bundle either way (Maps JS API requires a client-side key by design, same as the
  // Firebase config below) - restricting each key by HTTP referrer + API scope in Google Cloud
  // Console is the actual mitigation, not hiding the value here.
  agmApiKey: 'AIzaSyAvcDy5ZYc2ujCS6TTtI3RYX5QmuoV8Ffw',
  mapsModuleApiKey: 'AIzaSyCpVhQiwAllg1RAFaxMWSpQruuGARy0Y1k',
  chatGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
  
  firebaseConfig: {
    apiKey: "AIzaSyCfzZTfsfnMqz3fMhx0bNuMP71amhWlSaM",
 
  authDomain: "ezovion-opd.firebaseapp.com",
 
  projectId: "ezovion-opd",
 
  storageBucket: "ezovion-opd.firebasestorage.app",
 
  messagingSenderId: "384021528498",
 
  appId: "1:384021528498:web:8b5e98f90444aef782eeab",
 
  measurementId: "G-KPVN92ZPBV"
  },
  "abhaWebSocket" : "wss://dev-abha-app-crdgfyhdgkezbad8.southindia-01.azurewebsites.net/api/",
  // Default TenantBranchABDMSettings values (HIP / HIU / HFR id and facility status come from the user)
  abdmDefaults: {
    environment: 43,
    clientId: 'SBX_001307',
    clientSecret: '568e34f0-3c88-4703-8ac2-c1767b9bc19f',
    softwareLinked: true,
    gatewayBaseUrl: 'https://dev.abdm.gov.in/api/',
    callbackUrl: 'https://dev-abha-app-crdgfyhdgkezbad8.southindia-01.azurewebsites.net/'
  },

  signalrUrl: 'https://devsignalrapp-beczfrgadpfeepc0.southindia-01.azurewebsites.net/api/chatHub',

  // Optional MQTT broker for X6ManagerService to mirror Aabo X6 state to
  // (e.g. 'ws://<host>:9001'). Leave empty to disable — the device still
  // works fully over Bluetooth with no broker configured.
  mqttBrokerUrl: '',

  // Local Aabo Scope bridge process (see the sibling AaboScopeBridge project's
  // bridge-server.js). Must be running (`npm start`) alongside `ng serve` for
  // Aabo Scope to connect.
  scopeBridgeWsUrl: 'ws://localhost:8080',
};
